/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import AppDispatcher from '../dispatcher/AppDispatcher';
import Authentication from '../authentication/awsAuthentication';
import API from './awsApi';

class UserAPIClass {
    constructor() {
    }

    allUsers(handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-USER] all users");
            let params = {"Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/user', params), handler);
        })
        .catch((e) => handler.failure(e));
    }

    userByEmail(email,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            console.log("[API-USER] userByEmail:". email);
            let dataService = API.newClient();
            let params = {"email" : email, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/useremail' , {params:params}), handler);
        })
        .catch((e) => {
            console.log("[API-ERROR] " , e);
            handler.failure(e)
        });
    }

    allDealerUsers(dealerId, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-DEALER] dealer users :", dealerId);
            let params = {'dealerId' : dealerId,"Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/dealer/' + dealerId + '/users', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }


    allDealers(handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-DEALERS] all dealers");
            let params = {"Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/dealer', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }

    deleteDealer(dealer, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-DEALER] deleting: ", dealer);
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.delete('/api/v1/dealer', dealer), handler);
        })
        .catch((e) => handler.failure(e));

    }

    saveDealer(dealer, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-DEALER] saving: ", dealer);
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.post('/api/v1/dealer', dealer), handler);
        })
        .catch((e) => handler.failure(e));
    }

    saveUser(user, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            let dataService = API.newClient();

            console.log("[API-USER] saving: ", user);
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.post('/api/v1/user', user), handler);
        })
        .catch((e) => handler.failure(e));
    }

    async createUser(user) {
        let client = API.newClient();
        let request = {
            action : "CREATE-USER",
            user : user
        }
        return await API.securePut(client,`/api/v1/manage-user`, request);
    }

    async updateUser(user) {
        let client = API.newClient();
        return await API.securePost(client,`/api/v1/manage-user`, user);
    }

    async updateUserPassword(email,pass) {
        let client = API.newClient();
        let request = {
            action : "UPDATE-PASS",
            email : email,
            newPass : pass
        };
        return await API.securePut(client,`/api/v1/manage-user`, request);
    }

    async deleteUser(user) {
        let client = API.newClient();
        return await API.secureDelete(client,`/api/v1/manage-user?userId=${user.userId}`, {});
    }
}

const UserAPI = new UserAPIClass();
export default UserAPI;



// WEBPACK FOOTER //
// ./src/app/api/awsUserAPI.js